import React, { useState } from 'react'
import { Modal, SuspenseBoundary } from 'elements'
import { useModalBehavior } from 'hooks'
import CreateReportModal from './CreateReportModal'

export default function CreateReportModalContainer({
  modal,
  orgSlug,
  companyId,
  integrationResult,
}) {
  const [editing, setEditing] = useState(false)

  const modalBehavior = useModalBehavior(modal, {
    shouldClose: () => {
      if (editing) {
        return window.confirm('You have unsaved changes. Close anyway?')
      }

      return true
    },
    closingBehavior: () => {
      modal.closeAllOtherModals()
    },
  })

  return (
    <Modal modal={modalBehavior}>
      <SuspenseBoundary>
        <CreateReportModal
          modal={modal}
          modalBehavior={modalBehavior}
          editing={editing}
          setEditing={setEditing}
          orgSlug={orgSlug}
          integrationResult={integrationResult}
          companyId={companyId}
        />
      </SuspenseBoundary>
    </Modal>
  )
}
